import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createTransportEntry = createAsyncThunk('createTransportEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertTransport`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateTransportEntry = createAsyncThunk('updateTransportEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateTransport`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertLocationEntry = createAsyncThunk('insertLocationEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertLocationEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateLocation = createAsyncThunk('updateLocation', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateLocation`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchTransportData = createAsyncThunk('fetchTransportData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getTransportlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const fetchSingleTransport = createAsyncThunk('fetchSingleTransport', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getTransportlist&transportId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleTransport = createAsyncThunk('deleteSingleTransport', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteTransport&transportId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchLocationData = createAsyncThunk('fetchLocationData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getLocationdata`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleLocation = createAsyncThunk('fetchSingleLocation', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getLocationdata&locId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteLocation = createAsyncThunk('deleteLocation', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteLocation&locId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const transportSlice = createSlice({
    name: 'TransportData',
    initialState: {
        isLoading: false,
        transport: null,
        deleteTransport: null,
        singleTransport: null,
        locdata: null,
        singleloc: null,
        deleloc: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTransportData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchTransportData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.transport = action.payload;
        });
        builder.addCase(fetchTransportData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleTransport.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleTransport.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteTransport = action.payload;
        });
        builder.addCase(deleteSingleTransport.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleTransport.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleTransport.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleTransport = action.payload;
        });
        builder.addCase(fetchSingleTransport.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchLocationData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchLocationData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.locdata = action.payload;
        });
        builder.addCase(fetchLocationData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchSingleLocation.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleLocation.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleloc = action.payload;
        });
        builder.addCase(fetchSingleLocation.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteLocation.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteLocation.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleloc = action.payload;
        });
        builder.addCase(deleteLocation.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

    }
});

export default transportSlice.reducer;
